import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoutes';
// import Login from "../Pages/Auth/Login";
import Login from '../Pages/Auth/Login';
import Splash from '../Pages/Auth/Splash';
import { VendorRoutes } from './VendorRoutes';
import { AdminRoutes } from './AdminRoutes';
import SupervisorRoutes from './SupervisorRoutes';
import { ProviderRoutes } from './ProviderRoutes';
import ForgotPassword from '../Pages/Auth/ForgotPassword';
import ResetPassword from '../Pages/Auth/ResetPassword';
import About from '../Pages/Auth/About';
import Contact from '../Pages/Auth/Contact';
import { Booking } from '../Pages/Auth/Booking';
import PractitionerDetail from '../Pages/Auth/PractitionerDetail';
import Services from '../Pages/Auth/Services';
import Practitioners from '../Pages/Auth/Practitioners';
import BookConsultation from '../Pages/Auth/BookConsultation';
import PractitionerProfile from '../Pages/Auth/PractitionerProfile';
import TermsOfService from '../Pages/Auth/TermsOfService';
import TermsAndConditions from '../Pages/Auth/TermsAndConditions';
import PrivacyPolicy from '../Pages/Auth/PrivacyPolicy';
import YourJourney from '../Pages/Auth/YourJourney';
import ScopeOfPractice from '../Pages/Auth/ScopeOfPractice';
import Blog from '../Pages/Auth/Blog';
import BlogPost from '../Pages/Auth/BlogPost';
import ScrollToTop from '../components/ScrollToTop';
import { PublicLayout } from '../components/Layouts';
import SimplePracticeGate from '../components/SimplePracticeGate';
import Seo from '../components/Seo';
import NotFound from '../Pages/Auth/NotFound';

export default function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* Mounted once for the whole site: every SimplePractice booking CTA runs
          its human-verification step through this gate. */}
      <SimplePracticeGate />
      {/* Baseline document head for every route, driven by PAGE_SEO. Pages that
          need richer metadata (blog posts, practitioner profiles) render their
          own <Seo /> on top of this one. */}
      <Seo />
        <Routes>
        {/* Public routes with Header/Footer */}
        <Route element={<PublicLayout />}>
          <Route exact path="/" element={<Splash />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/practitioners" element={<Practitioners />} />
          <Route exact path="/booking" element={<Booking />} />
          <Route exact path="/book-consultation" element={<BookConsultation />} />
          <Route exact path="/practitioner-detail/:name" element={<PractitionerDetail />} />
          <Route exact path="/test-messages" element={<PractitionerDetail />} />
          <Route exact path="/practitioner-profile/:name" element={<PractitionerProfile />} />
          <Route exact path="/terms-of-service" element={<TermsOfService />} />
          <Route exact path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/your-journey" element={<YourJourney />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/blog/:slug" element={<BlogPost />} />
          <Route
            exact
            path="/scope-of-practice-and-legal-compliance"
            element={<ScopeOfPractice />}
          />
          {/* Catch-all. Router v6 ranks by specificity, not order, so every
              route declared elsewhere still wins over this one. */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Auth routes without Header/Footer */}
        {/* <Route exact path="/login" element={<Login />} /> */}
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path={`/reset-password/:id/:token`} element={<ResetPassword />} />
        {/* Vendor */}
        <Route element={<PrivateRoute role="vendor" />}>{VendorRoutes()}</Route>
        {/* Admin */}
        <Route element={<PrivateRoute role="admin" />}>{AdminRoutes()}</Route>
        {/* Supervisor */}
        <Route element={<PrivateRoute role="supervisor" />}>{SupervisorRoutes()}</Route>
        {/* Provider */}
        <Route element={<PrivateRoute role="doctor" />}>{ProviderRoutes()}</Route>
      </Routes>
    </BrowserRouter>
  );
}
